// eslint-disable-next-line import/prefer-default-export
export const tableProductFields = [
  {
    key: 'product', label: 'Produk', thClass: '!capitalize !bg-[#f4f4f4] !text-black font-medium !px-[12px]', tdClass: '!px-[12px] align-top',
  },
  {
    key: 'variant', label: 'Variasi', thClass: '!capitalize !bg-[#f4f4f4] !text-black font-medium !px-[12px]', tdClass: '!px-[12px] align-top',
  },
  {
    key: 'stock', label: 'Stok', thClass: '!capitalize !bg-[#f4f4f4] !text-black font-medium !px-[12px]', tdClass: '!px-[12px] align-top relative',
  },
]
